import { AnyParameter, NestedParam } from './SonForm';

// A Collection of Parameters for when we need to group together multiple elements
// for example
// const rules = {
//   name: 'attributeRules',
//   type: 'collection',
//   items: [
//     [
//       { name: 'attributeName', type: 'select', options: [{ value: 1 }] },
//       { name: 'conditionValue', type: 'text', value: 'test' },
//     ],
//     [
//       { name: 'attributeName', type: 'select', options: [{ value: 1 }] },
//       { name: 'conditionValue', type: 'text', value: '222' },
//     ],
//   ],
// };

export type CollectionParam<TName extends string, TParams extends AnyParameter> = NestedParam<'collection', TName> & {
  items: TParams[][];
};

/**
 * Create Name for collection payloads.
 * e.g
 *  - rule[0].name
 *  - rule[1].name
 */
export const createCollectionName = (collectionName: string, index: string | number, paramName: string) =>
  `${collectionName}[${index}].${paramName}`;
